<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<h1 class="fmtitle" epub:type="title"><span epub:type="pagebreak" id="page_5" title="5"><i>Contents</i></span></h1>
<p class="toc"><a href="#/xhtml/07_Prologue"><i>Prologue</i></a></p>
<p class="toct"><a href="#/xhtml/08_Chapter01"><span class="small">SPRING</span></a></p>
<p class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="small">SUMMER</span></span></p>
<p class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="small">AUTUMN</span></span></p>
<p class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="small">WINTER</span></span></p>
<p class="toct"><span href="#/xhtml/12_Glossary" title="Link target outside of Sample"><i>Glossary</i></span></p>
<p class="toc"><span href="#/xhtml/13_Acknowledgements" title="Link target outside of Sample"><i>Acknowledgements</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?76f2b2af